import "./style.css";

const AppSidebar = ({ children }) => {
  return (
    <div className="bg-transparent  translate-y-5 md:translate-y-0 fixed inset-0 my-4 pl-7 pr-3 h-[30vh] md:h-[calc(100vh-14%)] w-full md:w-[25.5vw]  transition-transform duration-300 md:translate-x-0  mt-[5.5rem] overflow-y-scroll  max-w-[600px] scrollbar-track-gry-200 scrollbar-custom">
      <div className="m-2">{children}</div>
    </div>
  );
};

export default AppSidebar;
